import { AppConfig, UserSession, showConnect } from '@stacks/connect'
import { Person } from '@stacks/profile'
import jwtDecode from 'jwt-decode'
import { signECDSA } from '@stacks/encryption'
import secp256k1 from 'secp256k1'

const appConfig = new AppConfig(['store_write', 'publish_data'])

export const userSession = new UserSession({ appConfig })

export function authenticate (callback, redirect = '/') {
  showConnect({
    appDetails: {
      name: 'HireVibes',
      icon: 'https://pbs.twimg.com/profile_images/1369266207015247874/RpLZYdV3_400x400.jpg'
    },
    redirectTo: redirect,
    onFinish: () => {
      const userData = getUserData()
      const token = userData.authResponseToken
      const user = jwtDecode(token)
      callback(userData, user)
    },
    userSession: userSession
  })
}

export function getUserData () {
  return userSession.loadUserData()
}

export function getUser () {
  const userData = userSession.loadUserData()
  return jwtDecode(userData.authResponseToken)
}

export function getUserSession () {
  return userSession
}

export async function getSignature (privateKey, text) {
  try {
    return await signECDSA(privateKey, text)
  } catch (e) {
    console.log('error', e)
  }
}

export function getSignObj (privateKey, text) {
  return secp256k1.ecdsaSign(text, privateKey)
}

export function getPerson () {
  return new Person(getUserData().profile)
}

export function disconnect (redirect = '/') {
  userSession.signUserOut(redirect)
}



// WEBPACK FOOTER //
// ./src/helpers/stack-auth.js